import request from "@/utils/request";

// 消息管理

//列表查询
export function getListByPage(data, log) {
  return request({
    url: "/common/notes/page",
    data,
    method: "post",
    log,
  });
}
export function getNotePage(data, log) {
  return request({
    url: "/common/notes/getNotePage",
    data,
    method: "post",
    log,
  });
}

// 删除全部
export function deleteAll(log) {
  return request({
    url: "/common/notes/deleteAll",
    log,
    method: "delete",
  });
}

// // 双击行，修改消息状态
// export function updateRead(noteId, log) {
//   return request({
//     url: `/common/notes/updateRead/${noteId}`,
//     method: "get",
//     log,
//   });
// }

// 根据接收人oid来判断是否有新的短讯
export function hasNewMessage(log) {
  return request({
    url: `/common/notes/hasNewMessage`,
    method: "get",
    log,
  });
}

//详情
export function loadByNoteId(params, log) {
  return request({
    url: `/otherSys/noteDetail/loadByNoteId`,
    method: "post",
    params,
    log,
  });
}
//更新消息状态
export function updateReadNode(params, log) {
  return request({
    url: `/common/notes/updateRead/${params.nodeId}`,
    method: "get",
    params,
    log,
  });
}

//消息推送
export function sendNoteDetail(data, log) {
  return request({
    url: `otherSys/noteDetail/sendNoteDetail`,
    method: "post",
    data,
    log,
  });
}

// 推送信息查找
export function findNotesByCondition(data, log) {
  return request({
    url: `common/notes/findNotesByCondition`,
    method: "post",
    data,
    log,
  });
}
